var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.8 143.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.7,952.4c-5.3,0.2-10.4,2.4-14.1,6.2c-31.9,32-56.5,58.8-85.8,88.8l-29.7-25.1c-8.4-7.6-21.3-6.9-28.9,1.5         c-7.6,8.4-6.9,21.3,1.5,28.9c0.3,0.3,0.6,0.5,0.9,0.8l44.3,37.5c8.1,6.9,20.2,6.4,27.7-1.2c36.8-36.9,62.9-66.3,98.9-102.3         c8.1-7.9,8.2-20.9,0.3-28.9C174.9,954.4,169.4,952.2,163.7,952.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.e9d8373b9534bbb2b6f02f1a31c009a3.svg";
export { ForwardRef as ReactComponent };